import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';

import { Button, Link, Spinner } from '../../components/';
import Input from '~COMPONENTS/formInputs/Input';
import ForgotInfoModal from '../../user/forgotInfoModal/ForgotInfoModal';

import { setValidationError } from '../actions';
import { getUserData } from '../../user/selectors';
import { isUserValidated, validationError } from '../reducer';
import { required } from '~APP_UTIL/formValidations';

class ImportLegacyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { validationError, setValidationError } = this.props;

    if (validationError !== '') {
      setValidationError('');
    }
  }

  setIsSubmitting = bool => this.setState({ isSubmitting: bool });

  handleSubmit = e => {
    e.preventDefault();
    this.setIsSubmitting(true);
    const {
      form: { values },
      importSubmit,
      user,
      type,
      reset
    } = this.props;
    let data = {
      username: values.legacyUsername,
      password: values.legacyPassword
    };
    if (type === 'modal') {
      data = { ...data, newUsername: user.username };
    }
    return importSubmit(data).then(() => {
      this.setIsSubmitting(false);
      reset('importLegacyAccount');
    });
  };

  renderModalLinks = () => (
    <div className='flex-container row center space-around'>
      <div className='prl3-sm'>
        <ForgotInfoModal type='username' />
      </div>
      <div className='prl3-sm'>
        <ForgotInfoModal type='password' />
      </div>
    </div>
  );

  renderLinks = () => (
    <div className='flex-container row center space-around'>
      <div className='prl3-sm'>
        <Link to='/legacy/username/recover' extraClassName='body-4 d-sm-b' data-desc='importLegacyAccount__link_next'>
          Forgot Username
        </Link>
      </div>
      <div className='prl3-sm'>
        <Link
          to='/legacy/password/recover'
          extraClassName='body-4 d-sm-b'
          data-desc='importLegacyAccount__link_forgot-password'
        >
          Forgot Password
        </Link>
      </div>
    </div>
  );

  render() {
    const { form, type, validationError } = this.props;
    const { isSubmitting } = this.state;
    return (
      <>
        <Field
          name='legacyUsername'
          type='text'
          component={Input}
          label='Username'
          validate={[required]}
          placeholder='Please enter your username'
          autoComplete='username'
          required
        />
        <Field
          name='legacyPassword'
          type='password'
          component={Input}
          label='Password'
          validate={[required]}
          placeholder='Please enter your password'
          autoComplete='current-password'
          required
          isPassword
        />
        {type && type === 'modal' ? this.renderModalLinks() : this.renderLinks()}
        <Button
          type='submit'
          disabled={form && form.syncErrors}
          extraClassName='mt10-sm pt2-sm pr5-sm pb2-sm pl5-sm full-width'
          data-desc='importLegacyAccount__form_submit'
          onClick={this.handleSubmit}
        >
          {isSubmitting ? <Spinner className='relative-container p3-sm' /> : 'Submit'}
        </Button>
        {validationError && <div className='text-color-error pt3-sm'>{validationError}</div>}
      </>
    );
  }
}

ImportLegacyAccount.propTypes = {
  ...formPropTypes,
  form: PropTypes.any,
  setValidationError: PropTypes.func.isRequired,
  validationError: PropTypes.string.isRequired,
  importSubmit: PropTypes.func.isRequired,
  type: PropTypes.string
};

ImportLegacyAccount.defaultProps = {
  form: null,
  type: null
};

const mapStateToProps = state => ({
  form: state.form.importLegacyAccount,
  isUserValidated: isUserValidated(state),
  user: getUserData(state),
  validationError: validationError(state)
});

const connector = connect(mapStateToProps, {
  setValidationError
});

export default reduxForm({
  form: 'importLegacyAccount',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(connector(ImportLegacyAccount));
